import React, { useState, useRef } from 'react'
import { Box, Typography, TextField, Select, MenuItem, Grid, BottomNavigation, BottomNavigationAction, TextareaAutosize, ThemeProvider, createTheme, Snackbar, Alert } from '@mui/material'
import { useForm, Controller } from 'react-hook-form'
import globalStyles from '../../utils/globalStyles'
import { useNavigate } from 'react-router-dom';
import axios from 'axios'
import legolasApi from '../../api/legolas'
import { Form, number } from 'react-admin'


const CreateNewProduct = (props) => {

    const formField = {
        name: '',
        attributeSet: '',
        oracleId: '',
        barcode: '',
        GTIN: '',
        brand: '',
        notes: '',
    };
    const errorField = {
        name: false,
        attributeSet: false,
        oracleId: false,
        barcode: false,
        GTIN: false,
        brand: false,
        notes: false,

    }

    const [listData, setListData] = React.useState([])
    const [brandData, setBrandData] = React.useState([])
    const [errormsg, setErrormsg] = React.useState(errorField);
    const { control } = useForm();
    const [formData, setFormData] = React.useState({});
    const [openAlert, setOpenAlert] = React.useState(false)
    const [alertText, setAlertText] = React.useState('')
    const [open, setOpen] = React.useState(false);
    const [openEdit, setOpenEdit] = React.useState(false);
    const [openError, setOpenError] = React.useState(false);
    const [error, setError] = React.useState('');
    const [message, setMessage] = React.useState(false);
    const [formValid, setFormValid] = React.useState(false)
    const [show, setShow] = React.useState("none")


    const backClickHandler = () => {
        navigate('/products/#')
    }

    const validateForm = () => {
        if (!(formData.name.length >= 4 && formData.name.length <= 100)) {
            setErrormsg({ ...errormsg, name: true });
            setShow('');
            return false; 
        } 
    
        if (formData.oracleId.length !== 12) {
            setErrormsg({ ...errormsg, oracleId: true });
            setShow('');
            return false; 
        }
    
        if (!formData.attributeSet) {
            setErrormsg({ ...errormsg, attributeSet: true });
            setShow('');
            return false; // Return false immediately when 'attributeSet' validation fails
        }
    
        // if (!formData.brand) {
        //     setErrormsg({ ...errormsg, brand: true });
        //     setShow('');
        //     return false; 
        // }
    
        setShow(''); 
        return true; // If all validations pass, return true
    }
    
    const inputlabelstyle = {
        marginTop: '10px',
        marginBottom: '0px',
        marginLeft: '5px'
    };

    const controllerFields = {
        margin: '10px 1%',
        width: '728px',

        borderBottom: '1px solid #2b3f7a',
        borderRadius: 0,
        "& .MuiFilledInput-input": {
            backgroundColor: '#fff !important'
        }

    }


    const navigate = useNavigate()



    React.useEffect(() => {
        axios.get(`${legolasApi.url}/admin/products/attributeset`).then((res) => {
            //console.log('att.set: ', res.data.data)
            const list = res.data.data.attributeSet
            console.log("j1", list)
            setListData(list)
        }).catch((error) => console.log('Error', error))
    }, [])


    React.useEffect(() => {
        axios.get(`${legolasApi.url}/admin/products/brand`).then((res) => {
            const brand = res.data.data.brand
            setBrandData(brand)
        }).catch((error) => console.log('Error', error))
    }, [])



    const handlechange = (event) => {
        //console.log("ti", event.target.value)

        const { name, value } = event.target
        setFormData({ ...formData, [name]: value });

    }
    const redirectHandler = () => {
        const redirectUrl = `/products`
        navigate(redirectUrl)

    }


    const refreshPage = () => {
        window.location.reload();

    }

    const handleSubmitCreate = () => {
        return {
            name: formData.name,
            attributeSet: formData.attributeSet,
            oracleId: formData.oracleId,
            barcode: formData.barcode,
            GTIN: formData.GTIN,
            brand: formData.brand,
            notes: formData.notes,
        }
    }

    const handleAlertGen = (msg) => {
        setAlertText(msg)
        setOpenAlert(true)
        setTimeout(() => {
            backClickHandler()
            setAlertText('')
            setOpenAlert(false)
        }, 3000)
    }


    const closeAlert = () => {
        setOpenAlert(false)
    }

    const theme = createTheme({
        typography: {
            allVariants: {
                fontFamily: 'serif',
                textTransform: 'none',
                fontSize: 12,
            },
        },
    });




    const submitForm = (event) => {
        event.preventDefault();
        if (validateForm()) {
            const savePayload = handleSubmitCreate();
            console.log("productLoad", savePayload);
            axios.post(`${legolasApi.url}/admin/products/add`, savePayload)
                .then((res) => {
                    //console.log('productSave', res);
                    const data = res.data
                    if (data.msg) {
                        handleAlertGen(data.msg)
                    }
                }).catch((error) => {
                    console.log('Error in submit res: ', error)
                })

        }

    }


    const close = () => {
        setOpen(false)
        setOpenEdit(false)
        setOpenError(false)
    };

    return (
        <>
            <React.Fragment>


                <Box sx={{
                    marginTop: '42px', marginLeft: '15px',
                    '& .MuiTypography-root': {
                        fontSize: '2.5rem',
                        fontWeight: 400,
                        color: '#000'
                    }
                }}>
                    <Snackbar
                        open={error}
                        autoHideDuration={3000}
                        onClose={close}
                        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                    >
                        <Alert onClose={close} severity="error" sx={{ width: '400px', marginTop: '100px' }}>
                            {error}
                        </Alert>
                    </Snackbar>

                    <Snackbar open={openAlert} autoHideDuration={3000} onClose={closeAlert} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
                        <Alert onClose={closeAlert} severity="success" sx={{ width: '400px', marginTop: '100px' }}>
                            {alertText}
                        </Alert>
                    </Snackbar>
                    <Typography variant='h3'>Create New Product</Typography>
                    <BottomNavigation
                        showLabels
                        sx={globalStyles.bottomNavigationMenuNew}>
                        <BottomNavigationAction onClick={() => navigate(-1)} label="Back"
                            sx={{
                                backgroundColor: '#2b3f7a !important',
                                border: '1px solid #2b3f7a !important',
                                color: '#fff !important',
                                '& .Mui-selected': {
                                    color: '#fff !important'
                                }
                            }} />
                    </BottomNavigation>
                </Box>
                <Grid container spacing={5} columns={24}>
                    <Grid item xs={16} sx={{ marginTop: '5px', marginBottom: '5px' }}>
                        <form style={{ marginLeft: '30%' }} onSubmit={submitForm} >
                            <Box sx={{ width: '400px', height: 'auto' }}>
                                <Typography sx={inputlabelstyle}>
                                    <span style={{ color: 'red', marginRight: '15px' }}>{errormsg.name && !formData.name ? '*' : ''}</span>
                                    {/* {errormsg.name && <span style={{ color: 'red' }}>Enter the Product Name</span>} */}

                                    {errormsg.name && !formData.name && (<span style={{ color: 'red' }}>[Enter the Product Name]</span>)}
                                </Typography>
                            </Box>

                            <Box>

                                <Controller
                                    name='name'
                                    control={control}
                                    rules={{ required: 'Enter the Product Name ' }}
                                    render={({ field }) => <TextField {...field} label="Name" placeholder='Enter the Product Name' type="text"
                                        onInput={(e) => { e.target.value = e.target.value.replace(/[]/g, '') }} required
                                        // value={formData.name ? formData.name : null}
                                        value={formData.name !== null ? formData.name : ''}
                                        onChange={handlechange} fullWidth />}
                                />
                                <ThemeProvider theme={theme}>

                                    <Typography variant="body1" style={{ color: 'red', display: show }}>
                                        Enter the character into  min 4 & max 100
                                    </Typography>
                                </ThemeProvider>

                            </Box>
                            <Box sx={{
                                display: 'inline-flex',
                                width: '100%',
                                alignItems: 'center',
                                margin: '10px',
                            }}>
                                <Box sx={{ width: '20%', marginTop: '10px' }}>{'AttributeSet*'}</Box>
                                <Box >
                                    <Controller
                                        name='attributeSet'
                                        control={control}
                                        rules={{ required: 'AttributeSet is required' }}
                                        render={({ field }) =>
                                            <Select
                                                name='attributeSet'
                                                label='AttributeSet'
                                                onChange={handlechange}
                                                value={formData.attributeSet ? formData.attributeSet : null}
                                                sx={{ width: '570px', borderRadius: '0px', border: '1px solid #000', marginLeft: '55px' }}
                                            >
                                                {
                                                    listData.map(list => {

                                                        return (
                                                            <MenuItem value={list._id}>{list.name}</MenuItem>
                                                        )
                                                    })
                                                }
                                            </Select>
                                        }
                                        type='number'
                                    />

                                </Box>
                                <Box sx={{ width: '50%', marginTop: '-23px', marginBottom: '-100px' }}>
                                    <ThemeProvider theme={theme}>

                                        <Typography sx={inputlabelstyle}>
                                            <span style={{ color: 'red', marginLeft: '-573px' }}>{errormsg.attributeSet && !formData.attributeSet ? '' : ''}</span>
                                            {errormsg.attributeSet && !formData.attributeSet && (<span style={{ color: 'red' }}>AttributeSet is required</span>)}
                                        </Typography>
                                    </ThemeProvider>
                                </Box>
                            </Box>
                            <Box sx={{ width: '400px', height: 'auto' }}>
                                <Typography sx={inputlabelstyle}>
                                    <span >{errormsg.oracleId && !formData.oracleId ? '*' : ''}</span>
                                    {errormsg.oracleId && !formData.oracleId && (<span style={{ color: 'red' }}>Enter oracleID</span>)}
                                </Typography>
                            </Box>
                            <Box>
                                <Controller
                                    name='oracleId'
                                    defaultValue=""
                                    control={control}
                                    rules={{ required: 'Enter OracleId with 12 digits', }}
                                    render={({ field }) => <TextField {...field} sx={{
                                        "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
                                            '-webkit-appearance': 'none',
                                        },
                                        "& input[type=number]": {
                                            MozAppearance: "textfield",
                                        },
                                    }} label='oracleId' placeholder='Enter OracleId' type="number"


                                        onInput={(e) => {
                                            e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 12)
                                        }} required
                                        // value={formData.oracleId ? formData.oracleId : null}
                                        value={formData.oracleId !== null ? formData.oracleId : ''}
                                        onChange={handlechange} fullWidth />}
                                />
                                <Box sx={{ width: '400px', height: 'auto' }}>
                                    <ThemeProvider theme={theme}>

                                        <Typography variant="body1" style={{ color: 'red', display: show }}>
                                            Enter oracleId  with 12 digits
                                        </Typography>
                                    </ThemeProvider>
                                </Box>
                            </Box>

                            <Box sx={{ width: '400px', height: 'auto' }}>
                                <Typography sx={inputlabelstyle}>
                                    <span >{errormsg.barcode && !formData.barcode ? '*' : ''}</span>
                                    {errormsg.barcode && !formData.barcode && (<span style={{ color: 'red' }}>Barcode is required</span>)}
                                </Typography>
                            </Box>
                            <Box>
                                <Controller
                                    name='barcode'
                                    control={control}
                                    rules={{ required: 'Barcode is required' }}
                                    render={({ field }) => <TextField {...field} sx={{
                                        "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
                                            '-webkit-appearance': 'none',
                                        },
                                        "& input[type=number]": {
                                            MozAppearance: "textfield",
                                        },
                                    }} label='Barcode' placeholder='Enter Barcode' type="number"
                                        onInput={(e) => {
                                            e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 12)
                                        }} required
                                        // value={formData.barcode ? formData.barcode : null}
                                        value={formData.barcode !== null ? formData.barcode : ''}

                                        onChange={handlechange} fullWidth />}
                                />
                                <Box sx={{ width: '400px', height: 'auto' }}>
                                    <ThemeProvider theme={theme}>

                                        <Typography variant="body1" style={{ color: 'red', display: show }}>
                                            Barcode is required
                                        </Typography>
                                    </ThemeProvider>
                                </Box>
                            </Box>
                            <Box sx={{ width: '400px', height: 'auto' }}>
                                <Typography sx={inputlabelstyle}>
                                    <span >{errormsg.GTIN && !formData.GTIN ? '*' : ''}</span>
                                    {errormsg.GTIN && !formData.GTIN && (<span style={{ color: 'red' }}>Please Enter the GTIN</span>)}
                                </Typography>
                            </Box>
                            <Box>
                                <Controller
                                    name='GTIN'
                                    control={control}
                                    placeholder='Enter the GTIN'
                                    rules={{ required: 'Please Enter the GTIN' }}
                                    render={({ field }) => <TextField {...field} sx={{
                                        "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
                                            '-webkit-appearance': 'none',
                                        },
                                        "& input[type=number]": {
                                            MozAppearance: "textfield",
                                        },
                                    }} label='GTIN ' placeholder='Enter the GTIN' type="number"
                                        onInput={(e) => {
                                            e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 12)
                                        }}
                                        // value={formData.GTIN ? formData.GTIN : null}
                                        value={formData.GTIN !== null ? formData.GTIN : ''}

                                        onChange={handlechange} fullWidth />}
                                />
                            </Box>
                            <Box sx={{
                                display: 'inline-flex',
                                width: '200%',
                                alignItems: 'center',
                                margin: '10px',

                            }}>

                                <Box sx={{ width: '20%', marginTop: '10px' }}>{'Brand*'}</Box>
                                <Controller
                                    name='brand'
                                    control={control}
                                    rules={{ required: 'Brand is required' }}
                                    render={({ field }) =>
                                        <Select
                                            name='brand'
                                            label='Brand'
                                            onChange={handlechange}
                                            // value={formData.brand !== null ? formData.brand : ''}
                                            value={formData.brand ? formData.brand : null}
                                            sx={{ width: '575px', borderRadius: '0px', border: '1px solid #000', marginLeft: '-150px' }}
                                        >
                                            {
                                                brandData.map(brand => {

                                                    return (
                                                        <MenuItem value={brand._id}>{brand.name}</MenuItem>
                                                    )
                                                })
                                            }
                                        </Select>
                                    }
                                    type='number'
                                />
                                <Box sx={{ width: '50%', marginTop: '-23px', marginBottom: '-100px' }}>
                                    <ThemeProvider theme={theme}>
                                        <Typography sx={inputlabelstyle}>
                                            <span style={{ color: 'red', marginLeft: '-577px' }}>{errormsg.brand && !formData.brand ? '' : ''}</span>
                                            {errormsg.brand && !formData.brandData && (<span style={{ color: 'red' }}>Brand is required</span>)}
                                        </Typography>
                                    </ThemeProvider>
                                    <Box >
                                    </Box>
                                </Box>
                            </Box>

                            <Box sx={{ width: '400px', height: 'auto' }}>

                                <Typography sx={inputlabelstyle}>
                                    <span style={{ color: 'red', marginRight: '15px' }}>{errormsg.notes && !formData.notes ? '*' : ''}</span>
                                    {errormsg.notes && !formData.notes && (<span style={{ color: 'red' }}>Please Enter notes</span>)}
                                </Typography>
                            </Box>
                            <Box sx={{ marginTop: '-16px' }}>
                                <Controller
                                    name='notes'
                                    control={control}
                                    rules={{ required: 'Please Enter notes' }}
                                    render={({ field }) => <TextareaAutosize {...field} label='Notes' style={controllerFields} placeholder=" Notes" minRows={4}
                                        // value={formData.notes ? formData.notes : null}
                                        value={formData.notes !== null ? formData.notes : ''}

                                        onChange={handlechange} fullWidth />}
                                />
                            </Box>

                            <Box sx={{ width: '100%', height: 'auto', backgroundColor: '#fff !important', margin: '40px 87.5px' }}>

                                <BottomNavigation
                                    showLabels
                                    sx={globalStyles.bottomNavigationMenuNew}>
                                    <BottomNavigationAction onClick={() => redirectHandler()} label="Cancle"
                                        sx={{
                                            borderRadius: '0px !important',
                                            backgroundColor: '#fff !important',
                                            border: '1px solid #2b3f7a !important',
                                            color: '#2b3f7a !important',

                                            '& .Mui-selected': {
                                                color: '#fff !important'
                                            }
                                        }} />

                                    <BottomNavigationAction onClick={refreshPage} label="Reset"
                                        sx={{
                                            borderRadius: '0px !important',
                                            backgroundColor: '#2b3f7a !important',
                                            border: '1px solid #2b3f7a !important',
                                            color: '#fff !important',
                                            '& .Mui-selected': {
                                                color: '#fff !important'
                                            }
                                        }} />

                                    <BottomNavigationAction type="submit" label="Create"
                                        sx={{
                                            borderRadius: '0px !important',
                                            backgroundColor: '#1da57a !important',
                                            border: '1px solid #1da57a !important',
                                            color: '#fff !important',
                                            '& .Mui-selected': {
                                                color: '#fff !important',

                                            }
                                        }} />
                                </BottomNavigation>
                            </Box>
                        </form>
                    </Grid>

                </Grid>



            </React.Fragment>


        </>
    )
}


export default CreateNewProduct;
